import React from "react";

class Row extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            accordian: true
        };
    };

    render() {

        return (
          <div className="rob-accordian__row">
              <div onClick={() => this.setState({accordian: !this.state.accordian})} className={  this.state.accordian ?  "rob-accordian__title" : "rob-accordian__title active"}>{this.props.title}</div>
              <div className={  this.state.accordian ?  "rob-accordian__content" : "rob-accordian__content active"}>
                  <div className={'rob-redactor'}  dangerouslySetInnerHTML={{__html: this.props.content}} ></div>
              </div>
          </div>
        )
    }
}

export default Row;




// WEBPACK FOOTER //
// ./src/components/elements/Row.js